<app-multi-selection-list-modal
  [id]="'schedule-availability'"
  [title]="'Select organizers' | translate"
  [searchPlaceholder]="'Search for organizer' | translate"
  [sections]="{ contentHeader, columns }"
  [fetchConfig]="{ fetch }"
  [filters]="filters"
  [emptyMessage]="'No organizers found' | translate"
  (confirm)="onConfirm($event)"
  (cancel)="onCancel($event)"
>
  <ng-template #contentHeader>
    {{ event.start_time | dateUserLocale: DateFormatEnum.FULLDATETIME }} -
    {{ event.end_time | dateUserLocale: DateFormatEnum.SHORTTIME }}
  </ng-template>

  <ng-template #userHeader>{{ 'Name' | translate }}</ng-template>
  <ng-template #userCell let-host>
    <app-lightweight-user-avatar
      width="32"
      [showName]="true"
      [isUser]="!!host"
      [profileImage]="host?.profile_image"
      [userRole]="host?.role"
      [userEmail]="host?.email"
      [userName]="host?.name"
    ></app-lightweight-user-avatar>
  </ng-template>

  <ng-template #availabilityHeader>{{ 'Availability' | translate }}</ng-template>
  <ng-template #availabilityCell let-host>
    <app-tutor-availability-status
      [status]="host.availabilityStatus"
    ></app-tutor-availability-status>
  </ng-template>
</app-multi-selection-list-modal>
